module.exports = __webpack_public_path__ + "img/flytoget.63f7a390.svg";